import { render } from "./SessionsPlayedListComponent.vue?vue&type=template&id=28fa3b2b&ts=true"
import script from "./SessionsPlayedListComponent.vue?vue&type=script&lang=ts"
export * from "./SessionsPlayedListComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__